import axios from 'axios';
import {
  Message,
  MessageBox,
    Loading
} from 'element-ui';
import msg from './msg'
import store from '../store';
import auth from '../utils/auth';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 创建axios实例
const service = axios.create({
  //baseURL: process.env.VUE_APP_AJAXURL, // api的base_url
    baseURL: window.location.protocol+"//"+process.env.VUE_APP_AJAXURL, // api的base_url
  timeout: 2*60*1000 // 请求超时时间,超过2分钟，超时
});

let loadingInstance;
// loading框设置局部刷新，且所有请求完成后关闭loading框
let _loading
let needLoadingRequestCount = 0 // 声明一个对象用于存储请求个数

function showFullScreenLoading () {
    if (needLoadingRequestCount === 0) {
        _loading = msg.loading();
    }
    needLoadingRequestCount++
}
function hideFullScreenLoading () {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        _loading.close()
    }
}

let logconfirm=null;
// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
    showFullScreenLoading()
  if (auth.getToken()) {
    config.headers['Authorization'] = auth.getToken(); // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
  }
  return config;
}, error => {

    hideFullScreenLoading()
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
})
// respone拦截器
service.interceptors.response.use(
  response => {
      hideFullScreenLoading()
      // loadingInstance.close();//关闭loading
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
      //下载的话，不处理，直接返回response
      if(response.headers.downflag){
          return response;
      }
    const res = response.data;
    if (response.status !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      });
    } else {
        if(response.data.f === false && response.data.selfopt != '1'){
            Message({
                message: response.data.msg,
                type: 'error',
                duration: 5 * 1000
            });
            return Promise.reject(response.data.msg);
        }else{
            return response.data;
        }
    }
  },
  error => {
      hideFullScreenLoading()
      if (error.response) {
          switch (error.response.status) {
              case 401:
                  logconfirm = logconfirm ||MessageBox.confirm('登录超时，请重新登录后操作', '确定登出', {
                      confirmButtonText: '重新登录',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                      //退出系统
                      store.commit("LOGOUT")
                  })
                  return Promise.reject('error');
              case 403:
                  Message({
                      message: '当前用户无相关操作权限！',
                      type: 'error',
                      duration: 5 * 1000
                  });
                  return Promise.reject('error');
          }
      }
      Message({
          message: error.message,
          type: 'error',
          duration: 5 * 1000
      });
    return Promise.reject(error);
  }
);

export default service;
